import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { api } from '../../utils/api';

interface AnalyticsState {
  metrics: any;
  loading: boolean;
  error: string | null;
}

const initialState: AnalyticsState = {
  metrics: null,
  loading: false,
  error: null,
};

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    updateStats: (state, action: PayloadAction<any>) => {
      // Merge incoming partial metrics into state.metrics
      state.metrics = { ...(state.metrics || {}), ...(action.payload || {}) };
    },
  },
});

export const { clearError, updateStats } = analyticsSlice.actions;
export default analyticsSlice.reducer;